module.exports = ":host .border-bottom {\n  border-bottom: 1px solid #dddddd; }\n\n:host .payment-schedule-date {\n  width: 120px; }\n\n:host .payment-schedule-table {\n  overflow-x: visible; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quotes/common/payment-schedule/payment-schedule.scss
// module id = ./web/modern/components/quotes/common/payment-schedule/payment-schedule.scss
// module chunks = 0